<template>
  <form @submit.prevent="handleSubmit(!v$.$invalid)" class="p-fluid">
    <div class="field">
      <div>
        <label
          for="ingredients_allergies"
          :class="{ 'p-error': v$.ingredients_allergies.$invalid && submitted }"
          >{{ $t("form.allergies_ingredients_allergies") }}</label
        >
        <AutoComplete
          style="display: grid"
          id="ingredients_allergies"
          :multiple="true"
          v-model="v$.ingredients_allergies.$model"
          :suggestions="filteredIngredients"
          @complete="filterIngredients($event)"
          optionLabel="attributes.key"
          :placeholder="$t('form.allergies_ingredients_placeholder')"
        >
          <template #chip="slotProps">
            {{ $t(slotProps.value.attributes.key) }}
          </template>

          <template #item="slotProps">
            {{ $t(slotProps.item.attributes.key) }}
          </template>
        </AutoComplete>
      </div>
    </div>
    <div class="field">
      <div>
        <label
          for="not_liked_ingredients"
          :class="{ 'p-error': v$.not_liked_ingredients.$invalid && submitted }"
          >{{ $t("form.allergies_not_liked_ingredients") }}</label
        >
        <AutoComplete
          style="display: grid"
          id="not_liked_ingredients"
          :multiple="true"
          v-model="v$.not_liked_ingredients.$model"
          :suggestions="filteredNotLikedIngredients"
          @complete="filterNotLikedIngredients($event)"
          optionLabel="attributes.key"
          :placeholder="$t('form.allergies_not_liked_ingredients_placeholder')"
        >
          <template #chip="slotProps">
            {{ $t(slotProps.value.attributes.key) }}
          </template>

          <template #item="slotProps">
            {{ $t(slotProps.item.attributes.key) }}
          </template>
        </AutoComplete>
      </div>
    </div>
    <div class="field">
      <h5>{{ $t('profile.preferred_course')}}</h5>
        <Dropdown v-model="preferred_course" :options="preferred_courses" optionLabel="name" optionValue="code" placeholder="" />
    </div>
    <div class="field">
      <h5>{{ $t('profile.sweet_or_savoury')}}</h5>
        <Dropdown v-model="sweet_or_savoury" :options="sweet_or_savouries" optionLabel="name" optionValue="code" placeholder="" />
    </div>

    <div class="field">
      <h5>{{ $t('profile.preferred_cooking_meal')}}</h5>
        <Dropdown v-model="preferred_cooking_meal" :options="preferred_cooking_meals" optionLabel="name" optionValue="code" placeholder="" />
    </div>


    <Button @click="submit()" type="submit" label="Submit" class="mt-2" />
  </form>
</template>
  
<script>
import { useVuelidate } from "@vuelidate/core";
import { mapFields } from "vuex-map-fields";
import { updateProfileInformation} from "../../service/UsersService";
import { importTranslations } from "@/service/Utils";

export default {
  setup: () => ({ v$: useVuelidate() }),
  mounted: function () {
     
  },
  created() {
   
    this.$store
      .dispatch(
        "ingredients/fetch",
        this.$store.getters["userdata/getAccessToken"]
      )
      .then(() => {
      
        importTranslations(this.ingredients, this.$i18n, '', 'value');
        this.labelLoaded = true;
        let allergies = this.$store.getters['profile/ingredients_allergies'].map((item) => {
        return item.id;
      });
        this.ingredients_allergies = this.$store.getters['ingredients/ingredients'].filter( (f) => allergies.includes(f.id) )

      });

      let notLiked = this.$store.getters['profile/not_liked_ingredients'].map((item) => {
        return item.id;
      });
        this.not_liked_ingredients = this.$store.getters['ingredients/ingredients'].filter( (f) => notLiked.includes(f.id) )
      
     
  },
  data() {
    return {
      //preferred_cooking_meal: "",
      preferred_cooking_meals: [
        { name: this.$t('preferred_cooking_meal.breakfast'), code: 'preferred_cooking_meal.breakfast' },
        { name: this.$t('preferred_cooking_meal.lunch'), code: 'preferred_cooking_meal.lunch' },
        { name: this.$t('preferred_cooking_meal.dinner'), code: 'preferred_cooking_meal.dinner' },
        { name: this.$t('preferred_cooking_meal.snack'), code: 'preferred_cooking_meal.snack' },

      ],
      //sweet_or_savoury: "",
      sweet_or_savouries: [
        { name: this.$t('sweet_or_savoury.sweet'), code: 'sweet_or_savoury.sweet' },
        { name: this.$t('sweet_or_savoury.savoury'), code: 'sweet_or_savoury.savoury' },
        { name: this.$t('sweet_or_savoury.both'), code: 'sweet_or_savoury.both' }
      ],
      //preferred_course: "",
      preferred_courses: [
        {name: this.$t('preferred_course.first_dishes'), code: 'preferred_course.first_dishes'},
        {name: this.$t('preferred_course.second_courses'), code: 'preferred_course.second_courses'},
        {name: this.$t('preferred_course.dessert'), code: 'preferred_course.dessert'},
        {name: this.$t('preferred_course_side_dishes'), code: 'preferred_course.side_disches'},
        {name: this.$t('preferred_course.appetizers'), code: 'preferred_course.appetizers'},
      ],
      submitted: false,
      filteredIngredients: [],
      filteredNotLikedIngredients: [],
      ingredients_allergies: [],
      not_liked_ingredients: [],
    };
  },
  validations() {
    return {
      ingredients_allergies: {},
      not_liked_ingredients: {},
    };
  },
  computed: {
    locales() {
      return this.$store.getters["labels/languages"];
    },
    ...mapFields("ingredients", ["ingredients"]),
    //...mapFields("profile", ["ingredients_allergies", "not_liked_ingredients"]),
    ...mapFields("profile", ["preferred_course", "sweet_or_savoury", "preferred_cooking_meal"]),
    locale: function () {
      return this.$store.getters["preferences/locale"];
    },
  },
  methods: {
    submit() {
      let userId = this.$store.getters["profile/id"];
      let accesstoken = this.$store.getters["userdata/getAccessToken"];
      let allergies = this.ingredients_allergies.map((item) => {
        return item.id;
      });
      let notLiked = this.not_liked_ingredients.map((item) => {
        return item.id;
      });



      updateProfileInformation(accesstoken, userId,  allergies, notLiked,this.preferred_course, this.sweet_or_savoury, this.preferred_cooking_meal ,  ).then(() => {
        this.$toast.add({
                        severity: "success",
                        summary: "",
                        detail: this.$t("toast.success"),
                        life: 3000,
                    });
      });
    },
    handleSubmit(isFormValid) {
      this.submitted = true;

      if (!isFormValid) {
        return;
      }
      this.$emit("changeStep");
    },
    return() {
      this.resetForm();
      this.$emit("returnStep");
    },
    filterIngredients(event) {
      if (this.ingredients_allergies === null) {
        this.ingredients_allergies = [];
      }
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredIngredients = [...this.ingredients];
        } else {
          this.filteredIngredients = [...this.ingredients]
            //TODO unire i filter
            //tolgo ricette già selezionate
            .filter((el) => {
              return !this.ingredients_allergies.some((e) => {
                return e.attributes.key === el.attributes.key;
              });
            })
            //cerco per lingua e nome cercato
            .filter((ingredient) => {
              let ingredientsTitle = ingredient.attributes.labels.data.find(
                (o) => o.attributes.locale === this.locale
              );
              return ingredientsTitle.attributes.value
                .toLowerCase()
                .includes(event.query.toLowerCase());
            });
        }
      }, 250);
    },
    filterNotLikedIngredients(event) {
      if (this.not_liked_ingredients === null) {
        this.not_liked_ingredients = [];
      }
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredNotLikedIngredients = [...this.ingredients];
        } else {
          this.filteredNotLikedIngredients = [...this.ingredients]
            //TODO unire i filter
            //tolgo ricette già selezionate
            .filter((el) => {
              return !this.not_liked_ingredients.some((e) => {
                return e.attributes.key === el.attributes.key;
              });
            })
            //cerco per lingua e nome cercato
            .filter((ingredient) => {
              let ingredientsTitle = ingredient.attributes.labels.data.find(
                (o) => o.attributes.locale === this.locale
              );
              return ingredientsTitle.attributes.value
                .toLowerCase()
                .includes(event.query.toLowerCase());
            });
        }
      }, 250);
    },
  },
};
</script>

<style scoped lang="scss">
h4 {
  font-family: raleway, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 28px;
  color: black;
}
</style>
